import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'

Vue.use(Router)

export default new Router({
  routes: [
	    {
	      	path: '/',
	      	name: 'Home',
	      	component: Home
	    },{
	      	path: '/main',
	      	name: 'Main',
	    	component:resolve => { require(['@/components/Main.vue'], resolve); }
	    },{
	    	path:'/book',
	    	name:'Book',
	    	component:resolve => { require(['@/components/Book.vue'], resolve); }
	    },{
	    	path:'/can',
	    	name:'Can',
	    	component:resolve => { require(['@/components/Can.vue'], resolve); }
	    },{
	    	path:'/logger',
	    	name:'Logger',
	    	component:resolve => { require(['@/components/Logger.vue'], resolve); }
	    },{
	    	path:'/w',
	    	name:'w',
	    	component:resolve => { require(['@/components/W.vue'], resolve); }
	    },{
	    	path:'/pic',
	    	name:'pic',
	    	component:resolve => { require(['@/components/Pic.vue'], resolve); }
	    },{
	    	path:'/car',
	    	name:'car',
	    	component:resolve => { require(['@/components/Car.vue'], resolve); }
	    },{
	    	path:'/down',
	    	name:'down',
	    	component:resolve => { require(['@/components/Down.vue'], resolve); }
	    },{
	    	path:'/update',
	    	name:'update',
	    	component:resolve => { require(['@/components/Update.vue'], resolve); }
	    }
  	]
})



// WEBPACK FOOTER //
// ./src/router/index.js